import axios from "axios";
import { endpoints } from "../_config";

class FeedbackService {
  /**
   * Get Feedbacks
   * @param {*} Bearer token
   * @returns
   */
  static async getFeedbacks(user) {
    return axios
      .get(endpoints.feedback.getFeedbacks, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { FeedbackService };
